import { Component, OnInit } from '@angular/core';
import {FormInlineiframeComponent} from "../form-inlineiframe/form-inlineiframe.component";

@Component({
	selector: 'tig-form-usermanagement',
	templateUrl: '../form-inlineiframe/form-inlineiframe.component.html',
	styleUrls: ['../form-inlineiframe/form-inlineiframe.component.scss']
})
export class FormLeadqualificationComponent extends FormInlineiframeComponent
{

	public static IFRAME_ID = 'iframe-leadqualification'

	/**
	 * Function > getIFrameID
	 */
	public getIFrameID()
	{
		return FormLeadqualificationComponent.IFRAME_ID;
	} // end function getIFrameID

}
